import AppEvents from 'Shared/app-events';
import Validation from 'Shared/validation';

import Util from './util';
import Culture from './culture';

import AOS from 'aos';

import Api from 'Api/api-module';
import MediaApi from 'Api/media-api';
import UserContextApi from 'Api/usercontext';

import BookmarkApi from 'Api/bookmark-api';
import CompareApi from 'Api/compare-api';
import CartApi from 'Api/cart-api';
import ProductApi from 'Api/product-api';

import CartModule from '../modules/cartModule';
import BookmarkModule from '../modules/bookmarkModule';
import CompareModule from '../modules/compareModule';

import Slider from 'Components/slider';
import Consent from 'Components/consent';
import AsideLeft from 'Components/asideLeft';
import AsideRight from 'Components/asideRight';

import Header from 'Components/header';
import Search from 'Components/search';
import Scanner from 'Components/barcodeScanner';

import ko from "knockout";
import "knockout-mapping";
import "knockout-pre-rendered";
import "knockout-bindings";

import { Tooltip } from "bootstrap";

import 'Shared/util';

window.jQuery = $;
window.$ = $;
window.jquery = $;

window.ko = ko;

class Components {
    constructor(vm) {
        this.consent = new Consent();
        this.header = new Header();

        if (document.getElementById("search-panel")) {
            this.search = new Search(vm);
        }

        this.asideLeft = new AsideLeft();
        this.asideRight = new AsideRight(vm);

        if (document.getElementById("aside-scanner")) {
            this.scanner = new Scanner();
        }
    }

    loadModule = () => {

    }
}

export default class BaseViewModel {
    constructor() {
        this.defaults();

        this.#bindEvents();

        this.media = MediaApi;
    }

    #bindEvents() {
        window.addEventListener("DOMContentLoaded", () => {
            document.body.classList.remove("init");

            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
        });

        document.addEventListener('aos:in', ({ detail }) => {
            console.log('animated in', detail);
        });

        document.addEventListener('aos:out', ({ detail }) => {
            console.log('animated out', detail);
        });

        //let header = document.querySelector("header[data-mode='Sticky'], header[data-mode='Fixed']")
        //if (header) {
        //    const resizeObserver = new ResizeObserver((entries) => {
        //        for (const entry of entries) {
        //            if (entry.borderBoxSize) {
        //                this.marginTop(entry.contentBoxSize[0].blockSize);
        //            }
        //        }
        //    });

        //    resizeObserver.observe(header);
        //}

        AppEvents.on(BookmarkApi.Events.BOOKMARKLIST_CREATED, () => {
            this.#updateUserContext();
        });

        AppEvents.on(BookmarkApi.Events.BOOKMARKLIST_DELETED, () => {
            this.#updateUserContext();
        });

        AppEvents.on(BookmarkApi.Events.BOOKMARKLIST_CHANGED, () => {
            this.#updateUserContext();
        });

        AppEvents.on(CartApi.Events.CART_CHANGED, () => {
            this.#updateUserContext();
        });

        AppEvents.on(CompareApi.Events.COMPARE_CHANGED, () => {
            this.#updateUserContext();
        });

        AppEvents.on(BookmarkApi.Events.ADD, args => {
            this.addToBookmarks(args.element, args.variantId);
        });

        AppEvents.on(CompareApi.Events.ADD, args => {
            this.addToCompare(args.element, args.variantId);
        });

        AppEvents.on(CartApi.Events.ADD, args => {
            this.addToCart(args.element, args);
        });

        AppEvents.on(CartApi.Events.CART_CHANGING, () => {
            this.contextLoading(true);
        });

        AppEvents.on("StatusBar.Add", (args) => {
            this.addProductToCart(args.element, args.items);
        });
    }

    get clientBag() {
        return requireOptions.pageOptions;
    }

    api = Api;

    mapping = {};

    contextLoaded = ko.observable(false);
    contextLoading = ko.observable(false);
    modelLoaded = ko.observable(false);
    widgetsLoaded = ko.observable(false);
    pluginsLoaded = ko.observable(false);
    loading = ko.observable(false);
    brsize = ko.observable();

    widgets = {};
    modules = {};
    plugins = {};
    components = new Components(this);

    marginTop = ko.observable();

    bodyCss = ko.pureComputed(() => {
        var classes = [];

        if (this.components.asideRight.isOpen()) {
            classes.push("aside-right--show");
        }

        if (this.components.asideLeft.isOpen()) {
            classes.push("aside-left--show");
        }

        //if (this.components.search.hasFocus()) {
        //    classes.push("search--focus");
        //}
        
        return classes.join(' ');
    });

    defaults() {
        Culture.defaults(requireOptions.globalOptions.uiCulture);
        Validation.defaults(requireOptions.globalOptions.uiCulture);
    }

    async init() {
        this.#loadUserContext();
        await this.#load();
        await this.#init();

        this.initControls();
    };

    #load = async () => await Promise.all([
        this.#loadWidgets(),
        this.#loadPlugins(),
        this.#loadModel()
    ]);

    async #init() {
        try {
            await this.#onPreInit();
            await this.#onInit();
            await this.#onPostInit();
        }
        catch (ex) {
            console.error(ex);
        }
    }

    initControls() {
        Slider.init();
        AOS.init();
    }

    initComponent = async (id, componentName, data) => {
        try {
            var module = await import(`Components/${componentName}`);

            this.components[id] = new module.default(data);
        } catch (e) {
            console.error(e.message);
        }
    }

    #onPreInit = async () => {
        AppEvents.preInit();
        Promise.resolve();
    }

    #onInit = () => Promise.all([
        this.#bindKnockout(),
    ]);

    #onPostInit = () => {
        AppEvents.postInit();

        document.querySelectorAll('ul.nav.nav-hover[role="tablist"] > li > .nav-link').forEach((item) => {        
            item.addEventListener('mouseenter', () => {
                var tabTrigger = new bootstrap.Tab(item)
                tabTrigger.show();
            });
        });

        Promise.resolve();
    }

    #loadSiteTemplates() {
        return this.loadTemplates(requireOptions.globalOptions.templatePath, [
            "price-info-tpl",
            "price-info-xs-tpl",
            "scale-discounts",
            "shipping-info-tpl",
            "salesinfo-tpl",
            "salesinfo__extendedunit",
            "salesinfo__inputcart",
            "salesinfo__cart",
            "productids-horizontal-tpl",
            "dl-item-tpl-h",
            "stock-tpl",
            "stock-traffic-light-tpl",
            "traffic-light-tpl",
            "availability-info-tpl",
            "availability-traffic-light",
            "availability-traffic-light-stock",
            "availability-stock"
        ]);
    }

    loadPageTemplates() {
        return Promise.resolve();
    }

    async loadTemplates(url, templateIds) {
        var html = await this.api.ds.get(url);
        var templates = $(html);

        if (templateIds)
        {
            for (var i = 0; i < templateIds.length; i++) {
                var templateId = "#" + templateIds[i];

                if (!$(templateId).length) {
                    var template = templates.filter(templateId);
                    if (!template.length) {
                        console.log("template '" + templateId + "' not found");
                    } else {
                        $("body").append(template);
                    }
                }
            }
        } else {
            $("body").append(templates);
        }
    }

    async #loadUserContext() {
        var mapping = {
            CartContainer: {
                create: (options) => new CartModule(options.data, this)
            },
            BookmarkContainer: {
                create: (options) => new BookmarkModule(options.data, this)
            },
            CompareContainer: {
                create: (options) => new CompareModule(options.data, this)
            }
        }

        try {
            var data = await UserContextApi.load();
            ko.mapping.fromJS(data, mapping, this);
        }
        finally {
            this.contextLoaded(true);
            this.contextLoading(false);
        }
    }

    async #updateUserContext() {
        this.contextLoading(true);

        try {
            var data = await UserContextApi.load();
            ko.mapping.fromJS(data, this);
        }
        finally {
            this.contextLoading(false);
        }
    }

    async #loadWidgets() {
        const elWidgets = document.querySelectorAll('[data-widget-module]');
        await Promise.all(Array.from(elWidgets).map(this.#loadWidget));

        this.widgetsLoaded(true);
    }

    #loadWidget = async el => {
        const module = await import(/* webpackChunkName: "widget-[request]" */ `../widgets/${el.dataset.widgetModule}`);
        const model = new module.default(this, el.dataset.widgetId, JSON.parse(el.dataset.widgetModel || "{}"));
        if (model.init) {
            model.init(el);
        }

        this.widgets[el.dataset.widgetId] = model;
    }

    async #loadPlugins() {

        const elPlugins = document.querySelectorAll('[data-plugin]');
        for (const el of elPlugins) {
            const pluginName = el.dataset["plugin"];

            const module = await import(/* webpackChunkName: "plugin-[request]" */ `../../../plugins/${pluginName}/scripts/store/plugin.js`);
            const plugin = module.default;
            if (plugin.init) {
                await plugin.init(el);
            }

            this.plugins[pluginName] = plugin;
        }

        console.log("plugins loaded");

        this.pluginsLoaded(true);
    }

    async #loadModel() {
        if (this.clientBag.View) {
            this.model = ko.mapping.fromJS(this.clientBag.View, this.mapping);
        }

        await this.loadModel();
        this.modelLoaded(true);
        AppEvents.modelLoaded();
        await this.afterModelLoaded();
    }

    loadModel() {
        return Promise.resolve();
    }

    beforeBind() {
        return Promise.all([
            this.#loadSiteTemplates(),
            this.loadPageTemplates()
        ]);
    }

    afterModelLoaded() {
        return Promise.resolve();
    }
    
    async #bindKnockout() {
        await this.beforeBind();
        ko.applyBindings(this);
    }

    async loadModule(name) {
        var module = await import(`../modules/${name}`);
        this.modules[name] = new module.default();
    }

    execute = (model, e) => {
        const element = e.currentTarget,
            cmd = element.dataset.command,
            id = element.dataset.id;

        switch (cmd) {
            case "watch":
                this.productInfo(element, id);
                break;
            case "cart":
                this.addToCart(element, id);
                break;
            case "bookmark":
                this.addToBookmarks(element, id);
                break;
            case "compare":
                this.addToCompare(element, id);
                break;
        }
    }

    productInfo = (element, variantId) => {
        AppEvents.emit(this.Events.SHOW_VARIANT, { variantId, el: element });
    }

    addToBookmarks = async (element, productId) => {
        Util.startLoading(element);

        try {
            await BookmarkApi.addItem(productId);

            this.showBookmark();
        } finally {
            Util.stopLoading(element);
        }
    }

    addToCart = async (element, args) => {
        Util.startLoading(element);

        try {
            await CartApi.addProduct({
                ProductId: args.ProductId(),
                ProductUnitId: args.OrderUnit.ProductUnitId(),
                Quantity: args.OrderUnit.quantity() || args.OrderUnit.DefaultQuantity()
            });

            args.OrderUnit.quantity(null);

            this.showCart();
            
        } finally {
            Util.stopLoading(element);
        }
    }

    addToCompare = async (element, productId) => {
        Util.startLoading(element);

        try {
            await CompareApi.addProduct(productId);
                
            this.showCompare();
        }
        finally {
            Util.stopLoading(element);
        }
    }

    async addProductToCart(element, items) {
        Util.startLoading(element);

        try {
            await CartApi.addProducts(items);

            this.showCart();

        } finally {
            Util.stopLoading(element);
        }
    }

    showAccount = () => AppEvents.emit("aside.account.show");
    showBookmark = () => AppEvents.emit("aside.bookmark.show");
    showCompare = () => AppEvents.emit("aside.compare.show");
    showCart = () => AppEvents.emit("aside.cart.show");
    showNav = () => AppEvents.emit("aside.nav.show");

    showFastEntry = () => AppEvents.emit("fastentry.show");
}